// Shared everywhere a username can show one, so the badge always looks and
// behaves the same instead of each page's own copy drifting (FollowListModal
// used to render this in --accent-primary/blue while every other page used
// --accent-link/teal — a real, visible inconsistency, not a style choice).
//
// Custom SVG rather than a stock icon: a dark brand-blue disc with a thin
// gold ring, echoing the embroidery/gold-thread accent used elsewhere in the
// app (Login.jsx's trim, the brand mark) instead of a flat generic checkmark.
export default function VerifiedBadge({ size = 18, style }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      role="img"
      aria-label="Verified"
      style={{
        flexShrink: 0,
        verticalAlign: -3,
        marginLeft: 4,
        filter: "drop-shadow(0 1px 1.5px rgba(0,0,0,0.2))",
        ...style
      }}
    >
      <title>Verified</title>
      <circle cx="12" cy="12" r="10.5" fill="var(--accent-primary)" stroke="var(--accent-gold)" strokeWidth="1.3" />
      <path
        d="M5.0 12.6 L9.8 17.9 L19.4 5.7"
        fill="none"
        stroke="#fff"
        strokeWidth="3.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
